export default __webpack_public_path__ + "static/media/clock-filled.37b9ae7a.svg";